import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
const Root = styled.div.withConfig({
  displayName: "MessageAction__Root",
  componentId: "sc-ltatoe-0"
})(["margin-top:var(--size-spacing-03);"]);
const MessageAction = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return children && /*#__PURE__*/React.createElement(Root, _extends({}, rest, {
    ref: ref
  }), children);
});
MessageAction.display = 'MessageAction';
MessageAction.defaultProps = {
  children: null
};
MessageAction.propTypes = {
  /**
   * @ignore
   * Sets the children, Usually is a string
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.array, PropTypes.node])
};
export default MessageAction;